import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Slider from 'builder/views/AiEnhanceOnboard/components/Steps/SliderAnimation/SliderAnimation'
import { Container as SliderContainer } from 'builder/views/AiEnhanceOnboard/components/Steps/SliderAnimation/styles'

import Media from 'builder/styles/media'
import { Variant } from '../../../types'

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  max-width: 448px;
  width: 100%;
  height: 100%;

  ${Media.Tablet`
    max-width: 540px;
  `}
`

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;

  ${Media.Phone`
    gap: 8px;
  `}
`

export const AnimationContainer = styled.div<{ variant: Variant }>`
  max-width: 544px;
  width: 100%;
  height: 544px;
  background-color: ${Colors.Neutral5};
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  justify-content: center;

  ${Media.Tablet`
    max-width: 540px;
    width: 100%;
    height: 336px;
  `}

  ${({ variant }) =>
    variant === 'b'
      ? Media.Phone`
        height: 368px;

        ${SliderContainer} {
          height: 368px;
        }
      `
      : Media.Phone`
        height: 238px;
        
        ${SliderContainer} {
          height: 238px;
        }
  `}
`

export const Video = styled.video`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
  transform: scale(1.002);
  transform-origin: center;
`

export const SliderAnimation = styled(Slider)``

export const ActionsContainer = styled.div`
  width: 100%;
  margin-top: auto;
`

export const Image = styled.img`
  width: 448px;
  height: 448px;
`
